/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationResponseBaseResponse as ModelsV3ApplicationApplicationResponseBaseResponse } from '../models/Models/v3/Application/application-response-base-response';
import { ApplicationWithdrawRequestBaseResponse as ModelsV3ApplicationApplicationWithdrawRequestBaseResponse } from '../models/Models/v3/Application/application-withdraw-request-base-response';
import { ApplicationUpdateVehicleResponseBaseResponse as ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse } from '../models/Models/v3/Application/Public/application-update-vehicle-response-base-response';
import { VehicleLoanFileRequestBaseResponse as ModelsV3ApplicationVehicleLoanFileRequestBaseResponse } from '../models/Models/v3/Application/vehicle-loan-file-request-base-response';
import { v3ApplicationVehicleApplicationIdFilePost$Json } from '../fn/vehicle-application/v-3-application-vehicle-application-id-file-post-json';
import { V3ApplicationVehicleApplicationIdFilePost$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-file-post-json';
import { v3ApplicationVehicleApplicationIdFilePost$Plain } from '../fn/vehicle-application/v-3-application-vehicle-application-id-file-post-plain';
import { V3ApplicationVehicleApplicationIdFilePost$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-file-post-plain';
import { v3ApplicationVehicleApplicationIdFilePost$Xml } from '../fn/vehicle-application/v-3-application-vehicle-application-id-file-post-xml';
import { V3ApplicationVehicleApplicationIdFilePost$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-file-post-xml';
import { v3ApplicationVehicleApplicationIdPut$Json$Json } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-json-json';
import { V3ApplicationVehicleApplicationIdPut$Json$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-json-json';
import { v3ApplicationVehicleApplicationIdPut$Json$Plain } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-json-plain';
import { V3ApplicationVehicleApplicationIdPut$Json$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-json-plain';
import { v3ApplicationVehicleApplicationIdPut$Json$Xml } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-json-xml';
import { V3ApplicationVehicleApplicationIdPut$Json$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-json-xml';
import { v3ApplicationVehicleApplicationIdPut$Xml$Json } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-xml-json';
import { V3ApplicationVehicleApplicationIdPut$Xml$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-xml-json';
import { v3ApplicationVehicleApplicationIdPut$Xml$Plain } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-xml-plain';
import { V3ApplicationVehicleApplicationIdPut$Xml$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-xml-plain';
import { v3ApplicationVehicleApplicationIdPut$Xml$Xml } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-xml-xml';
import { V3ApplicationVehicleApplicationIdPut$Xml$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-put-xml-xml';
import { v3ApplicationVehicleApplicationIdWithdrawPost$Json$Json } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-json-json';
import { V3ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-json-json';
import { v3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-json-plain';
import { V3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-json-plain';
import { v3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-json-xml';
import { V3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-json-xml';
import { v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-xml-json';
import { V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-xml-json';
import { v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-xml-plain';
import { V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-xml-plain';
import { v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-xml-xml';
import { V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-application-id-withdraw-post-xml-xml';
import { v3ApplicationVehicleBrokerPost$Json$Json } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-json-json';
import { V3ApplicationVehicleBrokerPost$Json$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-json-json';
import { v3ApplicationVehicleBrokerPost$Json$Plain } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-json-plain';
import { V3ApplicationVehicleBrokerPost$Json$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-json-plain';
import { v3ApplicationVehicleBrokerPost$Json$Xml } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-json-xml';
import { V3ApplicationVehicleBrokerPost$Json$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-json-xml';
import { v3ApplicationVehicleBrokerPost$Xml$Json } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-xml-json';
import { V3ApplicationVehicleBrokerPost$Xml$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-xml-json';
import { v3ApplicationVehicleBrokerPost$Xml$Plain } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-xml-plain';
import { V3ApplicationVehicleBrokerPost$Xml$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-xml-plain';
import { v3ApplicationVehicleBrokerPost$Xml$Xml } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-xml-xml';
import { V3ApplicationVehicleBrokerPost$Xml$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-broker-post-xml-xml';
import { v3ApplicationVehiclePost$Json$Json } from '../fn/vehicle-application/v-3-application-vehicle-post-json-json';
import { V3ApplicationVehiclePost$Json$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-post-json-json';
import { v3ApplicationVehiclePost$Json$Plain } from '../fn/vehicle-application/v-3-application-vehicle-post-json-plain';
import { V3ApplicationVehiclePost$Json$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-post-json-plain';
import { v3ApplicationVehiclePost$Json$Xml } from '../fn/vehicle-application/v-3-application-vehicle-post-json-xml';
import { V3ApplicationVehiclePost$Json$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-post-json-xml';
import { v3ApplicationVehiclePost$Xml$Json } from '../fn/vehicle-application/v-3-application-vehicle-post-xml-json';
import { V3ApplicationVehiclePost$Xml$Json$Params } from '../fn/vehicle-application/v-3-application-vehicle-post-xml-json';
import { v3ApplicationVehiclePost$Xml$Plain } from '../fn/vehicle-application/v-3-application-vehicle-post-xml-plain';
import { V3ApplicationVehiclePost$Xml$Plain$Params } from '../fn/vehicle-application/v-3-application-vehicle-post-xml-plain';
import { v3ApplicationVehiclePost$Xml$Xml } from '../fn/vehicle-application/v-3-application-vehicle-post-xml-xml';
import { V3ApplicationVehiclePost$Xml$Xml$Params } from '../fn/vehicle-application/v-3-application-vehicle-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class VehicleApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3ApplicationVehiclePost()` */
  static readonly V3ApplicationVehiclePostPath = '/v3/application/vehicle';

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehiclePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehiclePost$Json$Plain$Response(params?: V3ApplicationVehiclePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehiclePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehiclePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehiclePost$Json$Plain(params?: V3ApplicationVehiclePost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehiclePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehiclePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehiclePost$Json$Json$Response(params?: V3ApplicationVehiclePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehiclePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehiclePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehiclePost$Json$Json(params?: V3ApplicationVehiclePost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehiclePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehiclePost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehiclePost$Json$Xml$Response(params?: V3ApplicationVehiclePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehiclePost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehiclePost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehiclePost$Json$Xml(params?: V3ApplicationVehiclePost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehiclePost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehiclePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehiclePost$Xml$Plain$Response(params?: V3ApplicationVehiclePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehiclePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehiclePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehiclePost$Xml$Plain(params?: V3ApplicationVehiclePost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehiclePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehiclePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehiclePost$Xml$Json$Response(params?: V3ApplicationVehiclePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehiclePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehiclePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehiclePost$Xml$Json(params?: V3ApplicationVehiclePost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehiclePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehiclePost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehiclePost$Xml$Xml$Response(params?: V3ApplicationVehiclePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehiclePost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehiclePost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehiclePost$Xml$Xml(params?: V3ApplicationVehiclePost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehiclePost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationVehicleBrokerPost()` */
  static readonly V3ApplicationVehicleBrokerPostPath = '/v3/application/vehicle/broker';

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleBrokerPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleBrokerPost$Json$Plain$Response(params?: V3ApplicationVehicleBrokerPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehicleBrokerPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleBrokerPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleBrokerPost$Json$Plain(params?: V3ApplicationVehicleBrokerPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehicleBrokerPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleBrokerPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleBrokerPost$Json$Json$Response(params?: V3ApplicationVehicleBrokerPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehicleBrokerPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleBrokerPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleBrokerPost$Json$Json(params?: V3ApplicationVehicleBrokerPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehicleBrokerPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleBrokerPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleBrokerPost$Json$Xml$Response(params?: V3ApplicationVehicleBrokerPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehicleBrokerPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleBrokerPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleBrokerPost$Json$Xml(params?: V3ApplicationVehicleBrokerPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehicleBrokerPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleBrokerPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleBrokerPost$Xml$Plain$Response(params?: V3ApplicationVehicleBrokerPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehicleBrokerPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleBrokerPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleBrokerPost$Xml$Plain(params?: V3ApplicationVehicleBrokerPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehicleBrokerPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleBrokerPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleBrokerPost$Xml$Json$Response(params?: V3ApplicationVehicleBrokerPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehicleBrokerPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleBrokerPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleBrokerPost$Xml$Json(params?: V3ApplicationVehicleBrokerPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehicleBrokerPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleBrokerPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleBrokerPost$Xml$Xml$Response(params?: V3ApplicationVehicleBrokerPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
    return v3ApplicationVehicleBrokerPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleBrokerPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleBrokerPost$Xml$Xml(params?: V3ApplicationVehicleBrokerPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationResponseBaseResponse> {
    return this.v3ApplicationVehicleBrokerPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>): ModelsV3ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationVehicleApplicationIdPut()` */
  static readonly V3ApplicationVehicleApplicationIdPutPath = '/v3/application/vehicle/{applicationId}';

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdPut$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdPut$Json$Plain$Response(params: V3ApplicationVehicleApplicationIdPut$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v3ApplicationVehicleApplicationIdPut$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdPut$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdPut$Json$Plain(params: V3ApplicationVehicleApplicationIdPut$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdPut$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdPut$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdPut$Json$Json$Response(params: V3ApplicationVehicleApplicationIdPut$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v3ApplicationVehicleApplicationIdPut$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdPut$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdPut$Json$Json(params: V3ApplicationVehicleApplicationIdPut$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdPut$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdPut$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdPut$Json$Xml$Response(params: V3ApplicationVehicleApplicationIdPut$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v3ApplicationVehicleApplicationIdPut$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdPut$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdPut$Json$Xml(params: V3ApplicationVehicleApplicationIdPut$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdPut$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdPut$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdPut$Xml$Plain$Response(params: V3ApplicationVehicleApplicationIdPut$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v3ApplicationVehicleApplicationIdPut$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdPut$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdPut$Xml$Plain(params: V3ApplicationVehicleApplicationIdPut$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdPut$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdPut$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdPut$Xml$Json$Response(params: V3ApplicationVehicleApplicationIdPut$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v3ApplicationVehicleApplicationIdPut$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdPut$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdPut$Xml$Json(params: V3ApplicationVehicleApplicationIdPut$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdPut$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdPut$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdPut$Xml$Xml$Response(params: V3ApplicationVehicleApplicationIdPut$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v3ApplicationVehicleApplicationIdPut$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdPut$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdPut$Xml$Xml(params: V3ApplicationVehicleApplicationIdPut$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdPut$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV3ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationVehicleApplicationIdFilePost()` */
  static readonly V3ApplicationVehicleApplicationIdFilePostPath = '/v3/application/vehicle/{applicationId}/file';

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdFilePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3ApplicationVehicleApplicationIdFilePost$Plain$Response(params: V3ApplicationVehicleApplicationIdFilePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdFilePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdFilePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3ApplicationVehicleApplicationIdFilePost$Plain(params: V3ApplicationVehicleApplicationIdFilePost$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdFilePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>): ModelsV3ApplicationVehicleLoanFileRequestBaseResponse => r.body)
    );
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdFilePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3ApplicationVehicleApplicationIdFilePost$Json$Response(params: V3ApplicationVehicleApplicationIdFilePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdFilePost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdFilePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3ApplicationVehicleApplicationIdFilePost$Json(params: V3ApplicationVehicleApplicationIdFilePost$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdFilePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>): ModelsV3ApplicationVehicleLoanFileRequestBaseResponse => r.body)
    );
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdFilePost$Xml()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3ApplicationVehicleApplicationIdFilePost$Xml$Response(params: V3ApplicationVehicleApplicationIdFilePost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdFilePost$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdFilePost$Xml$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v3ApplicationVehicleApplicationIdFilePost$Xml(params: V3ApplicationVehicleApplicationIdFilePost$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdFilePost$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>): ModelsV3ApplicationVehicleLoanFileRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3ApplicationVehicleApplicationIdWithdrawPost()` */
  static readonly V3ApplicationVehicleApplicationIdWithdrawPostPath = '/v3/application/vehicle/{applicationId}/withdraw';

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Response(params: V3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain(params: V3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV3ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdWithdrawPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Response(params: V3ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdWithdrawPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Json$Json(params: V3ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV3ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Response(params: V3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml(params: V3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV3ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Response(params: V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain(params: V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV3ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Response(params: V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json(params: V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV3ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Response(params: V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml(params: V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV3ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

}
